var reactIs = { exports: {} };
export {
  reactIs as __module
};
